import CalculatingQuote from './pages/CalculatingQuote';
import EnterPostcode from './pages/EnterPostcode';
import PinRoof from './pages/PinRoof';
import QuotationOverview from './pages/QuotationOverview';
import SearchingAddress from './pages/SearchingAddress';
import useEbcSolarStore from './store/ebc-solar-store';
import { WidgetState } from './types/states';

const App = () => {
    const state = useEbcSolarStore((state) => state.state);

    switch (state) {
        case WidgetState.ENTER_POSTCODE: {
            return <EnterPostcode />;
        }
        case WidgetState.SEARCHING_ADDRESS: {
            return <SearchingAddress />;
        }
        case WidgetState.PIN_ROOF: {
            return <PinRoof />;
        }
        case WidgetState.CALCULATING_QUOTE: {
            return <CalculatingQuote />;
        }
        case WidgetState.QUOTATION_OVERVIEW: {
            return <QuotationOverview />;
        }
        default: {
            // Should never happen
            return <EnterPostcode />;
        }
    }
};

export default App;
